module.exports = __webpack_public_path__ + "components/flag/static/square/hr-2b368a4975ea167c8cadc2d7d1278d26.svg";